export default __webpack_public_path__ + "ubisoft-playtest-profile-mobile-steps-2-4.webp";